import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ListView } from '../../list-view/list-view';
import { ResipesService } from '../../shared/services/resipes-service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentUrl } from '../../shared/services/environment-url';

@Component({
  selector: 'app-list-resipes',
  imports: [ListView],
  templateUrl: './list-recipes.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './list-recipes.css',
})
export class ListResipes {
  resibesService?: ResipesService;

  constructor(
    private http: HttpClient,
    private envUrl: EnvironmentUrl,
  ) {
    this.resibesService = new ResipesService(this.http, this.envUrl);
  }
}
